import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreditNoteDetApi } from '../api/creditnotedet.api';
import { switchMap, map } from 'rxjs/operators';

import { CreditNoteDetData, CreditNoteDet } from '../../../interfaces/masters/creditnotedet' ;
@Injectable()
export class CreditNoteDetService extends CreditNoteDetData {

    constructor(private api: CreditNoteDetApi) {
      super();
    }
  
  
    list(url: string): Observable<CreditNoteDet[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CreditNoteDet>{
        return this.api.getById(url);
    }
  
    create(url: string, data:CreditNoteDet): Observable<CreditNoteDet[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:CreditNoteDet): Observable<CreditNoteDet> {
      debugger;
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  